import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './customModalStyle.scss';

class CustomModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: props.isOpen || false,
    };
    this.handleClose = this.handleClose.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
    this.handleBackdropClick = this.handleBackdropClick.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isOpen !== this.props.isOpen) {
      this.setState({ isOpen: this.props.isOpen });
    }
  }

  handleClose() {
    this.setState({ isOpen: false });
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  handleConfirm() {
    if (this.props.onConfirm) {
      this.props.onConfirm();
    }
  }

  handleBackdropClick(e) {
    if (e.target === e.currentTarget && this.props.closeOnBackdropClick) {
      this.handleClose();
    }
  }

  render() {
    const { isOpen } = this.state;
    const {
      title,
      size,
      centered,
      showCloseButton,
      confirmButtonText,
      showConfirmButton,
      showCancelButton,
      cancelButtonText,
      children,
      footer,
      animation,
    } = this.props;

    if (!isOpen) return null;

    const modalSize = size ? `modal-${size}` : '';
    const modalCentered = centered ? 'modal-dialog-centered' : '';
    const modalAnimation = animation !== false ? 'fade' : '';

    return (
      <div 
        className={`modal show d-block ${modalAnimation} modal-custom-overlay`} 
        tabIndex="-1" 
        role="dialog"
        onClick={this.handleBackdropClick}
      >
        <div className={`modal-dialog ${modalSize} ${modalCentered}`} role="document">
          <div className="modal-content modal-custom-content">
            <div className="modal-header modal-custom-header">
              <h5 className="modal-title">{title}</h5>
              {showCloseButton && (
                <button 
                  type="button" 
                  className="close" 
                  onClick={this.handleClose}
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              )}
            </div>
            
            <div className="modal-body modal-custom-body">
              {children}
            </div>
            
            {(footer || showConfirmButton || showCancelButton) && (
              <div className="modal-footer modal-custom-footer">
                {footer ? (
                  footer
                ) : (
                  <>
                    {showCancelButton && (
                      <button 
                        type="button" 
                        className="btn btn-secondary" 
                        onClick={this.handleClose}
                      >
                        {cancelButtonText || 'Cancel'}
                      </button>
                    )}
                    {showConfirmButton && (
                      <button 
                        type="button" 
                        className="btn btn-primary" 
                        onClick={this.handleConfirm}
                      >
                        {confirmButtonText || 'Confirm'}
                      </button>
                    )}
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

CustomModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  title: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'lg', 'xl']),
  centered: PropTypes.bool,
  showCloseButton: PropTypes.bool,
  confirmButtonText: PropTypes.string,
  showConfirmButton: PropTypes.bool,
  showCancelButton: PropTypes.bool,
  cancelButtonText: PropTypes.string,
  children: PropTypes.node,
  footer: PropTypes.node,
  animation: PropTypes.bool,
  closeOnBackdropClick: PropTypes.bool,
};

CustomModal.defaultProps = {
  title: 'Modal Title',
  size: 'md',
  centered: true,
  showCloseButton: true,
  showConfirmButton: false,
  showCancelButton: false,
  animation: true,
  closeOnBackdropClick: false,
};

export default CustomModal;